<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-card class="" elevation="" max-width="">
                    <v-card-title class="justify-center">MODIFICAR PRODUCTO</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <p>
                                    <router-link exact="" style="text-decoration: none" :to="{ name: 'inicioPanel' }">
                                        Inicio
                                    </router-link>
                                    /
                                    <router-link
                                        exact=""
                                        style="text-decoration: none"
                                        :to="{ name: 'productosPanel' }"
                                    >
                                        Productos
                                    </router-link>
                                    /
                                    <router-link
                                        exact=""
                                        style="text-decoration: none"
                                        :to="{
                                            name: 'productosEditarPanel',
                                            params: { idproducto: $route.params.idproducto },
                                        }"
                                    >
                                        Editar
                                    </router-link>
                                </p>
                            </v-col>
                            <v-col cols="12">
                                <v-divider></v-divider>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12 text-center" v-show="!mostrarContenido">
                                <v-progress-circular
                                    indeterminate
                                    color="primary"
                                    :size="100"
                                    :width="7"
                                ></v-progress-circular>
                            </v-col>
                        </v-row>

                        <v-form @submit.prevent="modificar()" v-show="mostrarContenido" :disabled="processForm">
                            <v-row>
                                <v-col cols="12">
                                    <v-alert
                                        type="error"
                                        v-model="alertError"
                                        dismissible
                                        ref="mensajeError"
                                        id="mensajeError"
                                    >
                                        <ul v-for="(errors, index) in listErrors" :key="index">
                                            <li v-text="errors[0]"></li>
                                        </ul>
                                    </v-alert>
                                </v-col>

                                <v-col cols="12">
                                    <v-select
                                        @change="evtTipoProducto"
                                        dense
                                        item-text="nombre"
                                        item-value="idtipo_producto"
                                        :items="resources.tipo_producto"
                                        label="Tipo producto (*)"
                                        outlined
                                        v-model="producto.idtipo_producto"
                                    ></v-select>
                                </v-col>

                                <v-col cols="12" xl="6" lg="6" md="6" sm="12">
                                    <v-text-field dense label="Nombre(*)" v-model="producto.nombre"></v-text-field>
                                </v-col>

                                <v-col cols="12" xl="6" lg="6" md="6" sm="12">
                                    <v-text-field dense label="Codigo" v-model="producto.codigo"></v-text-field>
                                </v-col>

                                <v-col cols="12" xl="6" lg="6" md="6" sm="12">
                                    <v-text-field
                                        type="number"
                                        min="0"
                                        dense
                                        label="Precio lista"
                                        v-model="producto.precio_lista"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" xl="6" lg="6" md="6" sm="12">
                                    <v-text-field
                                        type="number"
                                        min="0"
                                        dense
                                        label="Precio"
                                        v-model="producto.precio"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" xl="6" lg="6" md="6" sm="12" v-show="!ocultarCampo">
                                    <v-select
                                        dense
                                        item-text="nombre"
                                        item-value="idmodelo_producto"
                                        :items="resources.clase"
                                        multiple
                                        label="Clase"
                                        outlined
                                        v-model="producto.idclase"
                                    ></v-select>
                                </v-col>

                                <!-- <v-col cols="12" xl="6" lg="6" md="6" sm="12" v-show="!ocultarCampo">
                           <v-select
                           @change="getRangos()"
                           dense
                           item-text="nombre"
                           item-value="idcategoria"
                           :items="resources.categoria"
                           label="Categoria"
                           outlined
                           v-model="producto.idcategoria"
                           ></v-select>
                        </v-col> -->

                                <v-col cols="12" xl="6" lg="6" md="6" sm="12" v-show="!ocultarCampo">
                                    <v-select
                                        @change="getRangos()"
                                        dense
                                        item-text="nombre"
                                        item-value="idgenero"
                                        :items="resources.genero"
                                        label="Generos"
                                        outlined
                                        multiple
                                        v-model="producto.idgenero"
                                    ></v-select>
                                </v-col>

                                <v-col cols="12" xl="6" lg="6" md="6" sm="12" v-show="!ocultarCampo">
                                    <v-select
                                        dense
                                        item-text="nombre"
                                        item-value="idmarco"
                                        :items="resources.marco"
                                        label="Marco"
                                        outlined
                                        v-model="producto.idmarco"
                                    ></v-select>
                                </v-col>

                                <v-col cols="12" xl="6" lg="6" md="6" sm="12" v-show="!ocultarCampo">
                                    <v-select
                                        v-show="resources.rango.length > 0"
                                        dense
                                        item-text="nombre"
                                        item-value="idrango_edad"
                                        :items="resources.rango"
                                        label="Niños edad"
                                        outlined
                                        v-model="producto.idrango_edad"
                                    ></v-select>
                                </v-col>

                                <v-col cols="12" xl="6" lg="6" md="6" sm="12" v-show="!ocultarCampo">
                                    <v-select
                                        dense
                                        item-text="nombre"
                                        item-value="idmaterial"
                                        :items="resources.material"
                                        multiple
                                        label="Material"
                                        outlined
                                        v-model="producto.idmaterial"
                                        hide-details
                                    />
                                    <button
                                        type="button"
                                        class="py-1"
                                        @click="showSortableList.material = !showSortableList.material"
                                    >
                                        {{ showSortableList.material ? 'Ocultar' : 'Mostrar' }} lista
                                    </button>

                                    <SortableList
                                        v-if="showSortableList.material"
                                        item-text="nombre"
                                        item-value="idmaterial"
                                        :items="resources.material"
                                        v-model="producto.idmaterial"
                                    />
                                </v-col>

                                <v-col cols="12" xl="6" lg="6" md="6" sm="12" v-show="!ocultarCampo">
                                    <v-select
                                        dense
                                        item-text="nombre"
                                        item-value="idforma"
                                        :items="resources.forma"
                                        label="Forma"
                                        outlined
                                        multiple
                                        v-model="producto.idforma"
                                        hide-details
                                    />

                                    <button
                                        type="button"
                                        class="py-1"
                                        @click="showSortableList.forma = !showSortableList.forma"
                                    >
                                        {{ showSortableList.forma ? 'Ocultar' : 'Mostrar' }} lista
                                    </button>

                                    <SortableList
                                        v-if="showSortableList.forma"
                                        item-text="nombre"
                                        item-value="idforma"
                                        :items="resources.forma"
                                        v-model="producto.idforma"
                                    />
                                </v-col>

                                <v-col cols="12" xl="6" lg="6" md="6" sm="12" v-show="!ocultarCampo">
                                    <v-select
                                        dense
                                        item-text="nombre"
                                        item-value="idrostro"
                                        :items="resources.rostro"
                                        label="Rostro"
                                        outlined
                                        multiple
                                        v-model="producto.idrostro"
                                    ></v-select>
                                </v-col>

                                <v-col cols="12" xl="6" lg="6" md="6" sm="12" v-show="!ocultarCampo">
                                    <v-select
                                        dense
                                        item-text="nombre"
                                        item-value="idproducto_color"
                                        :items="resources.producto_color"
                                        label="Montura Color"
                                        outlined
                                        multiple
                                        v-model="producto.idproducto_color"
                                        hide-details
                                    />

                                    <button
                                        type="button"
                                        class="py-1"
                                        @click="showSortableList.color = !showSortableList.color"
                                    >
                                        {{ showSortableList.color ? 'Ocultar' : 'Mostrar' }} lista
                                    </button>

                                    <SortableList
                                        v-if="showSortableList.color"
                                        item-text="nombre"
                                        item-value="idproducto_color"
                                        :items="resources.producto_color"
                                        v-model="producto.idproducto_color"
                                    />
                                </v-col>

                                <v-col cols="12" xl="6" lg="6" md="6" sm="12" v-show="!ocultarCampo">
                                    <v-select
                                        dense
                                        item-text="nombre"
                                        item-value="idtag"
                                        :items="resources.tag"
                                        label="Tags"
                                        outlined
                                        multiple
                                        v-model="producto.idtag"
                                    ></v-select>
                                </v-col>

                                <v-col cols="12" xl="4" lg="4" md="4" sm="12">
                                    <v-text-field
                                        type="number"
                                        min="0"
                                        dense
                                        label="Inventario"
                                        v-model="producto.inventario"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" xl="4" lg="4" md="4" sm="12" v-show="!ocultarCampo">
                                    <v-text-field
                                        type="number"
                                        dense
                                        label="Puente"
                                        v-model="producto.puente"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" xl="4" lg="4" md="4" sm="12" v-show="!ocultarCampo">
                                    <v-text-field
                                        type="number"
                                        dense
                                        label="Luna"
                                        v-model="producto.luna"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" xl="4" lg="4" md="4" sm="12" v-show="!ocultarCampo">
                                    <v-text-field
                                        type="number"
                                        dense
                                        label="Largo"
                                        v-model="producto.largo"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" xl="4" lg="4" md="4" sm="12" v-show="!ocultarCampo">
                                    <v-text-field
                                        type="number"
                                        dense
                                        label="Ancho"
                                        v-model="producto.ancho"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" xl="4" lg="4" md="4" sm="12" v-show="!ocultarCampo">
                                    <v-text-field
                                        type="number"
                                        dense
                                        label="Alto"
                                        v-model="producto.alto"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" xl="4" lg="4" md="4" sm="12" v-show="false">
                                    <v-text-field
                                        type="text"
                                        dense
                                        label="Unidad de medida"
                                        v-model="producto.unidad_medida"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" v-show="!ocultarCampo">
                                    <v-text-field
                                        dense
                                        label="Altura luna"
                                        v-model="producto.altura_luna"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" xl="12" lg="12" md="12" sm="12" v-show="!ocultarCampo">
                                    <v-select
                                        dense
                                        item-text="nombre"
                                        item-value="relevancia"
                                        :items="relevanciaRango"
                                        label="Relevancia"
                                        outlined
                                        v-model="producto.relevancia"
                                    ></v-select>
                                </v-col>

                                <v-col cols="12" xl="3" lg="3" md="3" sm="12">
                                    <p class="my-0">Clip On:</p>
                                    <v-switch
                                        :true-value="1"
                                        :false-value="0"
                                        v-model="producto.clip_on"
                                        flat
                                        :label="producto.clip_on ? 'SI' : 'NO'"
                                    ></v-switch>
                                </v-col>

                                <v-col cols="12" xl="3" lg="3" md="3" sm="12">
                                    <p class="my-0">Descuentos:</p>
                                    <v-switch
                                        :true-value="1"
                                        :false-value="0"
                                        v-model="producto.en_descuento"
                                        flat
                                        :label="producto.en_descuento ? 'SI' : 'NO'"
                                    ></v-switch>
                                </v-col>

                                <v-col cols="12" xl="3" lg="3" md="3" sm="12">
                                    <p class="my-0">Luz Azul Gratis:</p>
                                    <v-switch
                                        :true-value="1"
                                        :false-value="0"
                                        v-model="producto.luz_azul_gratis"
                                        flat
                                        :label="producto.luz_azul_gratis ? 'SI' : 'NO'"
                                    ></v-switch>
                                </v-col>

                                <v-col cols="12" xl="3" lg="3" md="3" sm="12">
                                    <p class="my-0">Envio Gratis:</p>
                                    <v-switch
                                        :true-value="1"
                                        :false-value="0"
                                        v-model="producto.envio_gratis"
                                        flat
                                        :label="producto.envio_gratis ? 'SI' : 'NO'"
                                    ></v-switch>
                                </v-col>

                                <v-col cols="12">
                                    <v-text-field dense label="Link Video" v-model="producto.linkVideo"></v-text-field>
                                </v-col>

                                <v-col cols="12">
                                    <v-textarea dense label="Descripción" v-model="producto.descripcion"></v-textarea>
                                </v-col>

                                <v-col cols="12" v-if="producto.idclase.includes(3)">
                                    <v-textarea
                                        dense
                                        label="Descripción para lentes de sol"
                                        v-model="producto.descripcion_tipo_sol"
                                    ></v-textarea>
                                </v-col>

                                <v-col cols="12">
                                    <p class="my-0">Contenido</p>
                                    <ckeditor
                                        :editor-url="apiUrl('js/ckeditor/ckeditor.js')"
                                        v-model="producto.contenido"
                                        :config="{
                                            filebrowserBrowseUrl: '/plugin_externos/ckfinder/ckfinder.html',
                                            allowedContent: true,
                                        }"
                                    ></ckeditor>
                                </v-col>

                                <v-col cols="12">
                                    <p>Imagenes:</p>
                                    <p class="text-center">
                                        <v-btn
                                            :loading="loaderImagen"
                                            color="primary"
                                            @click="
                                                $refs.iptImagen.value = '';
                                                $refs.iptImagen.click();
                                            "
                                        >
                                            <v-icon left>mdi-cloud-upload-outline</v-icon>
                                            CARGAR IMAGENES
                                        </v-btn>
                                    </p>
                                    <input
                                        style="display: none"
                                        multiple
                                        type="file"
                                        ref="iptImagen"
                                        @change.prevent="cargarImagenes"
                                        accept="image/*"
                                    />
                                    <div class="custom-my-dropzone">
                                        <v-row v-show="imagen.length > 0">
                                            <v-col cols="12">
                                                <v-simple-table dense="" fixed-header="">
                                                    <template v-slot:default>
                                                        <thead class="text-no-wrap">
                                                            <tr>
                                                                <th>MOVER</th>
                                                                <th>ORDEN</th>
                                                                <th>IMAGEN</th>
                                                                <th>ORIENTACIÓN</th>
                                                                <th>NOMBRE</th>
                                                                <th>ELIMINAR</th>
                                                            </tr>
                                                        </thead>
                                                        <draggable
                                                            @update="cambiarOrdenImagen"
                                                            v-model="imagen"
                                                            tag="tbody"
                                                            handle=".cursor-move"
                                                        >
                                                            <tr v-for="(img, index) in imagen" :key="index">
                                                                <td class="cursor-move">
                                                                    <v-icon>mdi-drag-variant</v-icon>
                                                                </td>
                                                                <td v-text="img.orden"></td>
                                                                <td>
                                                                    <v-img
                                                                        height="120"
                                                                        width="100"
                                                                        :src="img.url"
                                                                        contain
                                                                    />
                                                                </td>
                                                                <td>
                                                                    {{ img.perfil }}
                                                                </td>
                                                                <td>
                                                                    <v-text-field
                                                                        dense
                                                                        label="Nombre"
                                                                        v-model="img.nombre"
                                                                        @input="
                                                                            (newVal) => handleImageError(newVal, img)
                                                                        "
                                                                        :error-messages="img.error"
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <v-btn
                                                                        icon
                                                                        color="red"
                                                                        small
                                                                        @click.prevent="
                                                                            eliminarImagen(img.idproducto_imagen, index)
                                                                        "
                                                                    >
                                                                        <v-icon>mdi-trash-can</v-icon>
                                                                    </v-btn>
                                                                </td>
                                                            </tr>
                                                        </draggable>
                                                    </template>
                                                </v-simple-table>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </v-col>

                                <v-col cols="12" v-show="!ocultarCampo">
                                    <p>Colores:</p>
                                    <p class="text-center">
                                        <v-btn
                                            :loading="loaderImagenColor"
                                            color="primary"
                                            @click="
                                                $refs.iptImagenesColor.value = '';
                                                $refs.iptImagenesColor.click();
                                            "
                                        >
                                            <v-icon left>mdi-cloud-upload-outline</v-icon>
                                            CARGAR COLORES
                                        </v-btn>
                                    </p>
                                    <input
                                        style="display: none"
                                        multiple
                                        type="file"
                                        ref="iptImagenesColor"
                                        @change.prevent="cargarImagenColor"
                                        accept="image/*"
                                    />
                                    <div class="custom-my-dropzone">
                                        <v-row v-show="imagen_color.length > 0">
                                            <v-col cols="12">
                                                <v-simple-table dense="" fixed-header="">
                                                    <template v-slot:default>
                                                        <thead class="text-no-wrap">
                                                            <tr>
                                                                <th>MOVER</th>
                                                                <th>ORDEN</th>
                                                                <th>IMAGEN</th>
                                                                <th>ORIENTACIÓN</th>
                                                                <th>NOMBRE</th>
                                                                <th>ELIMINAR</th>
                                                            </tr>
                                                        </thead>
                                                        <draggable
                                                            @update="cambiarOrdenImagenesColor"
                                                            v-model="imagen_color"
                                                            tag="tbody"
                                                            handle=".cursor-move"
                                                        >
                                                            <tr v-for="(img, index) in imagen_color" :key="index">
                                                                <td class="cursor-move">
                                                                    <v-icon>mdi-drag-variant</v-icon>
                                                                </td>
                                                                <td v-text="img.orden"></td>
                                                                <td>
                                                                    <v-img
                                                                        height="120"
                                                                        width="100"
                                                                        :src="img.url"
                                                                        contain
                                                                    />
                                                                </td>
                                                                <td>
                                                                    {{ img.perfil }}
                                                                </td>
                                                                <td>
                                                                    <v-text-field
                                                                        dense
                                                                        label="Nombre"
                                                                        v-model="img.nombre"
                                                                        @input="
                                                                            (newVal) => handleImageError(newVal, img)
                                                                        "
                                                                        :error-messages="img.error"
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <v-btn
                                                                        icon
                                                                        color="red"
                                                                        small
                                                                        @click.prevent="
                                                                            eliminarImagenesColor(
                                                                                img.idproducto_imagen_color
                                                                            )
                                                                        "
                                                                    >
                                                                        <v-icon>mdi-trash-can</v-icon>
                                                                    </v-btn>
                                                                </td>
                                                            </tr>
                                                        </draggable>
                                                    </template>
                                                </v-simple-table>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </v-col>

                                <v-col cols="4" v-show="!ocultarCampo">
                                    <p>Imagen Probador:</p>
                                    <input
                                        style="display: none"
                                        type="file"
                                        ref="iptProbadorVirutal"
                                        @change.prevent="cargarProbadorVirtual"
                                        accept="image/*"
                                    />
                                    <div class="custom-my-dropzone">
                                        <v-row>
                                            <v-col cols="12" class="text-center" v-show="urlProbadorVirutal === ''">
                                                <v-btn
                                                    :loading="loaderProbadorVirtual"
                                                    color="primary"
                                                    @click="
                                                        $refs.iptProbadorVirutal.value = '';
                                                        $refs.iptProbadorVirutal.click();
                                                    "
                                                >
                                                    <v-icon left>mdi-cloud-upload-outline</v-icon>
                                                    CARGAR PROBADOR VIRTUAL
                                                </v-btn>
                                            </v-col>
                                            <v-col cols="12" class="text-center" v-show="urlProbadorVirutal !== ''">
                                                <v-btn icon color="red" small @click.prevent="eliminarProbadorVirtual">
                                                    <v-icon>mdi-trash-can</v-icon>
                                                </v-btn>
                                                <v-img :src="urlProbadorVirutal" height="200" contain></v-img>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </v-col>

                                <v-col cols="4" v-show="!ocultarCampo">
                                    <p>Imagen Probador SOL:</p>
                                    <input
                                        style="display: none"
                                        type="file"
                                        ref="iptProbadorVirutalSol"
                                        @change.prevent="cargarProbadorVirtualSol"
                                        accept="image/*"
                                    />
                                    <div class="custom-my-dropzone">
                                        <v-row>
                                            <v-col cols="12" class="text-center" v-show="urlProbadorVirutalSol === ''">
                                                <v-btn
                                                    :loading="loaderProbadorVirtualSol"
                                                    color="primary"
                                                    @click="
                                                        $refs.iptProbadorVirutalSol.value = '';
                                                        $refs.iptProbadorVirutalSol.click();
                                                    "
                                                >
                                                    <v-icon left>mdi-cloud-upload-outline</v-icon>
                                                    CARGAR PROBADOR VIRTUAL SOL
                                                </v-btn>
                                            </v-col>
                                            <v-col cols="12" class="text-center" v-show="urlProbadorVirutalSol !== ''">
                                                <v-btn
                                                    icon
                                                    color="red"
                                                    small
                                                    @click.prevent="eliminarProbadorVirtualSol"
                                                >
                                                    <v-icon>mdi-trash-can</v-icon>
                                                </v-btn>
                                                <v-img :src="urlProbadorVirutalSol" height="200" contain></v-img>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </v-col>

                                <v-col cols="4" v-show="!ocultarCampo">
                                    <p>Imagen cuadrada para ads:</p>
                                    <input
                                        style="display: none"
                                        type="file"
                                        ref="imgCuadrado"
                                        @change.prevent="cargarImgCuadrado"
                                        accept="image/*"
                                    />
                                    <div class="custom-my-dropzone">
                                        <v-row>
                                            <v-col cols="12" class="text-center" v-show="urlImgCuadrado === ''">
                                                <v-btn
                                                    :loading="loaderImgCuadrado"
                                                    color="primary"
                                                    @click="
                                                        $refs.imgCuadrado.value = '';
                                                        $refs.imgCuadrado.click();
                                                    "
                                                >
                                                    <v-icon left>mdi-cloud-upload-outline</v-icon>
                                                    CARGAR IMAGEN CUADRADA
                                                </v-btn>
                                            </v-col>
                                            <v-col cols="12" class="text-center" v-show="urlImgCuadrado !== ''">
                                                <v-btn icon color="red" small @click.prevent="eliminarImgCuadrado">
                                                    <v-icon>mdi-trash-can</v-icon>
                                                </v-btn>
                                                <v-img :src="urlImgCuadrado" height="200" contain></v-img>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </v-col>

                                <v-col cols="4" v-show="!ocultarCampo">
                                    <p>Probador TR - Frontal:</p>
                                    <input
                                        style="display: none"
                                        type="file"
                                        ref="iptProbadorTrFrontal"
                                        @change.prevent="cargarProbadorTrFrontal"
                                        accept="image/*"
                                    />
                                    <div class="custom-my-dropzone">
                                        <v-row>
                                            <v-col cols="12" class="text-center" v-show="urlProbadorTrFrontal === ''">
                                                <v-btn
                                                    :loading="loaderProbadorTrFrontal"
                                                    color="primary"
                                                    @click="
                                                        $refs.iptProbadorTrFrontal.value = '';
                                                        $refs.iptProbadorTrFrontal.click();
                                                    "
                                                >
                                                    <v-icon left>mdi-cloud-upload-outline</v-icon>
                                                    CARGAR FRONTAL TR
                                                </v-btn>
                                            </v-col>
                                            <v-col cols="12" class="text-center" v-show="urlProbadorTrFrontal !== ''">
                                                <v-btn icon color="red" small @click.prevent="eliminarProbadorTrFrontal">
                                                    <v-icon>mdi-trash-can</v-icon>
                                                </v-btn>
                                                <v-img :src="urlProbadorTrFrontal" height="200" contain></v-img>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </v-col>

                                <v-col cols="4" v-show="!ocultarCampo">
                                    <p>Probador TR - Frontal SOL:</p>
                                    <input
                                        style="display: none"
                                        type="file"
                                        ref="iptProbadorTrFrontalSol"
                                        @change.prevent="cargarProbadorTrFrontalSol"
                                        accept="image/*"
                                    />
                                    <div class="custom-my-dropzone">
                                        <v-row>
                                            <v-col cols="12" class="text-center" v-show="urlProbadorTrFrontalSol === ''">
                                                <v-btn
                                                    :loading="loaderProbadorTrFrontalSol"
                                                    color="primary"
                                                    @click="
                                                        $refs.iptProbadorTrFrontalSol.value = '';
                                                        $refs.iptProbadorTrFrontalSol.click();
                                                    "
                                                >
                                                    <v-icon left>mdi-cloud-upload-outline</v-icon>
                                                    CARGAR FRONTAL SOL TR
                                                </v-btn>
                                            </v-col>
                                            <v-col cols="12" class="text-center" v-show="urlProbadorTrFrontalSol !== ''">
                                                <v-btn
                                                    icon
                                                    color="red"
                                                    small
                                                    @click.prevent="eliminarProbadorTrFrontalSol"
                                                >
                                                    <v-icon>mdi-trash-can</v-icon>
                                                </v-btn>
                                                <v-img :src="urlProbadorTrFrontalSol" height="200" contain></v-img>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </v-col>

                                <v-col cols="4" v-show="!ocultarCampo">
                                    <p>Probador TR - Patita Izquierda:</p>
                                    <input
                                        style="display: none"
                                        type="file"
                                        ref="iptProbadorTrPatitaIzq"
                                        @change.prevent="cargarProbadorTrPatitaIzq"
                                        accept="image/*"
                                    />
                                    <div class="custom-my-dropzone">
                                        <v-row>
                                            <v-col cols="12" class="text-center" v-show="urlProbadorTrPatitaIzq === ''">
                                                <v-btn
                                                    :loading="loaderProbadorTrPatitaIzq"
                                                    color="primary"
                                                    @click="
                                                        $refs.iptProbadorTrPatitaIzq.value = '';
                                                        $refs.iptProbadorTrPatitaIzq.click();
                                                    "
                                                >
                                                    <v-icon left>mdi-cloud-upload-outline</v-icon>
                                                    CARGAR PATITA IZQ TR
                                                </v-btn>
                                            </v-col>
                                            <v-col cols="12" class="text-center" v-show="urlProbadorTrPatitaIzq !== ''">
                                                <v-btn
                                                    icon
                                                    color="red"
                                                    small
                                                    @click.prevent="eliminarProbadorTrPatitaIzq"
                                                >
                                                    <v-icon>mdi-trash-can</v-icon>
                                                </v-btn>
                                                <v-img :src="urlProbadorTrPatitaIzq" height="200" contain></v-img>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </v-col>

                                <v-col cols="4" v-show="!ocultarCampo">
                                    <p>Probador TR - Patita Derecha:</p>
                                    <input
                                        style="display: none"
                                        type="file"
                                        ref="iptProbadorTrPatitaDer"
                                        @change.prevent="cargarProbadorTrPatitaDer"
                                        accept="image/*"
                                    />
                                    <div class="custom-my-dropzone">
                                        <v-row>
                                            <v-col cols="12" class="text-center" v-show="urlProbadorTrPatitaDer === ''">
                                                <v-btn
                                                    :loading="loaderProbadorTrPatitaDer"
                                                    color="primary"
                                                    @click="
                                                        $refs.iptProbadorTrPatitaDer.value = '';
                                                        $refs.iptProbadorTrPatitaDer.click();
                                                    "
                                                >
                                                    <v-icon left>mdi-cloud-upload-outline</v-icon>
                                                    CARGAR PATITA DER TR
                                                </v-btn>
                                            </v-col>
                                            <v-col cols="12" class="text-center" v-show="urlProbadorTrPatitaDer !== ''">
                                                <v-btn
                                                    icon
                                                    color="red"
                                                    small
                                                    @click.prevent="eliminarProbadorTrPatitaDer"
                                                >
                                                    <v-icon>mdi-trash-can</v-icon>
                                                </v-btn>
                                                <v-img :src="urlProbadorTrPatitaDer" height="200" contain></v-img>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </v-col>

                                <v-col cols="4" v-show="!ocultarCampo">
                                    <v-text-field
                                        dense
                                        type="number"
                                        step="0.0001"
                                        label="Probador TR - Offset Y (PC)"
                                        v-model.number="producto.probador_tr_offset_y"
                                    />
                                </v-col>

                                <v-col cols="4" v-show="!ocultarCampo">
                                    <v-text-field
                                        dense
                                        type="number"
                                        step="0.0001"
                                        label="Probador TR - Offset Y (Móvil)"
                                        v-model.number="producto.probador_tr_offset_y_movil"
                                    />
                                </v-col>

                                <v-col cols="4" v-show="!ocultarCampo">
                                    <v-text-field
                                        dense
                                        type="number"
                                        step="0.01"
                                        label="Probador TR - Ancho (mm)"
                                        v-model="producto.probador_tr_ancho_mm"
                                    />
                                </v-col>

                                <v-col cols="12" v-show="!ocultarCampo">
                                    <v-slider
                                        v-model.number="producto.probador_tr_offset_y"
                                        label="Probador TR - Offset Y (PC)"
                                        min="-1"
                                        max="0.5"
                                        step="0.01"
                                        thumb-label="always"
                                        dense
                                    >
                                        <template v-slot:prepend>
                                            <span class="caption">-1</span>
                                        </template>
                                        <template v-slot:append>
                                            <span class="caption">0.5</span>
                                        </template>
                                    </v-slider>
                                </v-col>

                                <v-col cols="12" v-show="!ocultarCampo">
                                    <v-slider
                                        v-model.number="producto.probador_tr_offset_y_movil"
                                        label="Probador TR - Offset Y (Móvil)"
                                        min="-1"
                                        max="0.5"
                                        step="0.01"
                                        thumb-label="always"
                                        dense
                                    >
                                        <template v-slot:prepend>
                                            <span class="caption">-1</span>
                                        </template>
                                        <template v-slot:append>
                                            <span class="caption">0.5</span>
                                        </template>
                                    </v-slider>
                                </v-col>

                                <v-col cols="12" v-show="!ocultarCampo">
                                    <v-btn
                                        color="primary"
                                        :disabled="!puedeProbarCamaraTr"
                                        @click="abrirProbadorCamaraTr(false)"
                                    >
                                        <v-icon left>mdi-camera</v-icon>
                                        Probar cámara (Probador TR)
                                    </v-btn>
                                    <v-btn
                                        class="ml-2"
                                        outlined
                                        color="primary"
                                        v-show="urlProbadorTrFrontalSol"
                                        :disabled="!puedeProbarCamaraTr"
                                        @click="abrirProbadorCamaraTr(true)"
                                    >
                                        <v-icon left>mdi-camera</v-icon>
                                        Probar cámara (SOL)
                                    </v-btn>
                                    <div v-if="!puedeProbarCamaraTr" class="caption grey--text mt-1">
                                        Sube la foto frontal y ambas patitas del probador TR para poder probar la
                                        cámara.
                                    </div>
                                </v-col>

                                <v-col cols="12">
                                    <v-select
                                        dense
                                        item-text="texto"
                                        item-value="valor"
                                        :items="resources.estado"
                                        label="Estado(*)"
                                        outlined
                                        v-model="producto.estado"
                                    ></v-select>
                                </v-col>

                                <v-col cols="12" class="text-center">
                                    <v-btn class="mr-2" type="submit" :loading="processForm" color="success" large="">
                                        <v-icon left="" large="">mdi-content-save-edit</v-icon>
                                        MODIFICAR
                                    </v-btn>
                                    <v-btn
                                        :to="{ name: 'productosPanel' }"
                                        type="button"
                                        :loading="processForm"
                                        color="error"
                                        large=""
                                    >
                                        <v-icon left="" large="">mdi-close</v-icon>
                                        CANCELAR
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import draggable from 'vuedraggable';
    import SortableList from '@/components/SortableList.vue';

    export default {
        components: {
            draggable,
            SortableList,
        },
        data() {
            return {
                resources: {
                    tipo_producto: [],
                    clase: [],
                    categoria: [],
                    marco: [],
                    rango: [],
                    material: [],
                    forma: [],
                    genero: [],
                    rostro: [],
                    producto_color: [],
                    tag: [],
                    estado: [
                        {
                            texto: 'Habilitado',
                            valor: 1,
                        },
                        {
                            texto: 'Inhabilitado',
                            valor: 0,
                        },
                    ],
                },
                producto: {
                    _method: 'PUT',
                    idproducto: '',
                    idclase: [],
                    idtipo_producto: '',
                    idcategoria: '',
                    idgenero: [],
                    idmarco: '',
                    idforma: [],
                    idrango_edad: '',
                    idmaterial: [],
                    idproducto_color: [],
                    idtag: [],
                    nombre: '',
                    codigo: '',
                    descripcion: '',
                    descripcion_tipo_sol: '',
                    inventario: '',
                    precio: '',
                    precio_lista: '',
                    puente: '',
                    luna: '',
                    ancho: '',
                    largo: '',
                    alto: '',
                    altura_luna: '',
                    clip_on: 0,
                    en_descuento: 0,
                    luz_azul_gratis: 0,
                    envio_gratis: 0,
                    linkVideo: '',
                    imagen_probador: '',
                    imagen_probador_sol: '',
                    imagen_cuadrado: '',
                    probador_tr_frontal: '',
                    probador_tr_frontal_sol: '',
                    probador_tr_patita_izq: '',
                    probador_tr_patita_der: '',
                    probador_tr_offset_y: -0.275,
                    // Altura propia para celular — por defecto la de PC + 0.06 (ajuste de cámara móvil)
                    probador_tr_offset_y_movil: -0.215,
                    probador_tr_ancho_mm: '',
                    estado: 1,
                    relevancia: 20,
                    idrostro: [],
                    contenido: null,
                    unidad_medida: '',
                },
                urlProbadorVirutal: '',
                urlProbadorVirutalSol: '',
                urlImgCuadrado: '',
                urlProbadorTrFrontal: '',
                urlProbadorTrFrontalSol: '',
                urlProbadorTrPatitaIzq: '',
                urlProbadorTrPatitaDer: '',
                imagen: [],
                imagen_color: [],
                ocultarCampo: false,
                mostrarContenido: false,
                processForm: false,
                listErrors: [],
                alertError: false,
                loaderImagen: false,
                loaderImagenColor: false,
                loaderProbadorVirtual: false,
                loaderProbadorVirtualSol: false,
                loaderImgCuadrado: false,
                loaderProbadorTrFrontal: false,
                loaderProbadorTrFrontalSol: false,
                loaderProbadorTrPatitaIzq: false,
                loaderProbadorTrPatitaDer: false,
                showSortableList: {
                    material: false,
                    forma: false,
                    color: false,
                },
            };
        },
        computed: {
            relevanciaRango: () => {
                let rango = [];
                for (let val = 1; val <= 20; val++) {
                    rango.push(val);
                }
                return rango;
            },
            puedeProbarCamaraTr() {
                return Boolean(
                    this.producto.idproducto &&
                        this.urlProbadorTrFrontal &&
                        this.urlProbadorTrPatitaIzq &&
                        this.urlProbadorTrPatitaDer
                );
            },
        },
        methods: {
            abrirProbadorCamaraTr(esSol = false) {
                if (!this.puedeProbarCamaraTr) return;

                const url =
                    process.env.VUE_APP_URL_WEB +
                    'probador-tr-test/' +
                    this.producto.idproducto +
                    '/' +
                    (esSol ? 1 : 0);

                window.open(url, '_blank', 'width=560,height=860');
            },
            // Mensajes desde /probador-tr-test (ver probadorTrTest.blade.php):
            //  - ptr-token-request: pide el token del CMS para poder guardar el Offset Y
            //  - ptr-offset-guardado: avisa que guardó un Offset Y, para que este formulario
            //    no lo pise con el valor viejo al hacer "Guardar"
            onMensajeProbadorTr(event) {
                const datos = event.data || {};
                if (typeof datos.type !== 'string' || !datos.type.startsWith('ptr-')) return;

                // Solo se responde a la web propia (VUE_APP_URL_WEB): el token se envía con
                // ese targetOrigin, así ninguna otra página puede recibirlo. No se exige que
                // sea justo la última ventana abierta — eso fallaba si había otra pestaña del
                // tester abierta o si esta vista se recargaba (hot reload) entre medio.
                const origenWeb = new URL(process.env.VUE_APP_URL_WEB).origin;
                if (event.origin !== origenWeb || !event.source) {
                    console.warn('[probador-tr] mensaje ignorado, origen', event.origin, '≠', origenWeb);
                    return;
                }

                if (datos.type === 'ptr-token-request') {
                    const token = this.$session.get('token');
                    if (!token) {
                        console.warn('[probador-tr] el tester pidió el token pero no hay sesión en el CMS');
                        return;
                    }
                    event.source.postMessage({ type: 'ptr-token', token }, event.origin);
                    return;
                }

                if (
                    datos.type === 'ptr-offset-guardado' &&
                    Number(datos.idproducto) === Number(this.producto.idproducto) &&
                    ['probador_tr_offset_y', 'probador_tr_offset_y_movil'].includes(datos.campo)
                ) {
                    this.producto[datos.campo] = Number(datos.valor);
                }
            },
            validateImageName(val) {
                if (val) {
                    const regex = /^[a-zA-Z0-9-.:]+$/;
                    return regex.test(val);
                }
                return true;
            },
            handleImageError(newVal, input) {
                input.error = [];
                if (!this.validateImageName(newVal)) {
                    input.error.push('El nombre solo puede contener letras, números y guiones.');
                }
                if (newVal.trim() === '') {
                    input.error.push('El nombre no puede estar vacío.');
                }
            },

            evtTipoProducto() {
                if (this.producto.idtipo_producto == 2) {
                    this.ocultarCampo = true;
                } else {
                    this.ocultarCampo = false;
                }
            },

            cargarProbadorVirtual(event) {
                this.loaderProbadorVirtual = true;

                if (this.urlProbadorVirutal !== '') {
                    this.$toasted.error('Ya hay un archivo cargado');
                    this.loaderProbadorVirtual = false;
                    return;
                }

                if (event.target.files.length > 0) {
                    let imagen = event.target.files[0];
                    this.urlProbadorVirutal = URL.createObjectURL(imagen);
                    this.producto.imagen_probador = imagen;
                }

                this.loaderProbadorVirtual = false;
            },

            eliminarProbadorVirtual() {
                this.urlProbadorVirutal = '';
                this.producto.imagen_probador = '';
            },

            cargarProbadorVirtualSol(event) {
                this.loaderProbadorVirtualSol = true;

                if (this.urlProbadorVirutalSol !== '') {
                    this.$toasted.error('Ya hay un archivo cargado');
                    this.loaderProbadorVirtualSol = false;
                    return;
                }

                if (event.target.files.length > 0) {
                    let imagen = event.target.files[0];
                    this.urlProbadorVirutalSol = URL.createObjectURL(imagen);
                    this.producto.imagen_probador_sol = imagen;
                }

                this.loaderProbadorVirtualSol = false;
            },

            eliminarProbadorVirtualSol() {
                this.urlProbadorVirutalSol = '';
                this.producto.imagen_probador_sol = '';
            },

            cargarImgCuadrado(event) {
                this.loaderImgCuadrado = true;

                if (this.urlImgCuadrado !== '') {
                    this.$toasted.error('Ya hay un archivo cargado');
                    this.loaderImgCuadrado = false;
                    return;
                }

                if (event.target.files.length > 0) {
                    let imagen = event.target.files[0];
                    this.urlImgCuadrado = URL.createObjectURL(imagen);
                    this.producto.imagen_cuadrado = imagen;
                }

                this.loaderImgCuadrado = false;
            },

            eliminarImgCuadrado() {
                this.urlImgCuadrado = '';
                this.producto.imagen_cuadrado = '';
            },

            cargarProbadorTrFrontal(event) {
                this.loaderProbadorTrFrontal = true;

                if (this.urlProbadorTrFrontal !== '') {
                    this.$toasted.error('Ya hay un archivo cargado');
                    this.loaderProbadorTrFrontal = false;
                    return;
                }

                if (event.target.files.length > 0) {
                    let imagen = event.target.files[0];
                    this.urlProbadorTrFrontal = URL.createObjectURL(imagen);
                    this.producto.probador_tr_frontal = imagen;
                }

                this.loaderProbadorTrFrontal = false;
            },

            eliminarProbadorTrFrontal() {
                this.urlProbadorTrFrontal = '';
                this.producto.probador_tr_frontal = '';
            },

            cargarProbadorTrFrontalSol(event) {
                this.loaderProbadorTrFrontalSol = true;

                if (this.urlProbadorTrFrontalSol !== '') {
                    this.$toasted.error('Ya hay un archivo cargado');
                    this.loaderProbadorTrFrontalSol = false;
                    return;
                }

                if (event.target.files.length > 0) {
                    let imagen = event.target.files[0];
                    this.urlProbadorTrFrontalSol = URL.createObjectURL(imagen);
                    this.producto.probador_tr_frontal_sol = imagen;
                }

                this.loaderProbadorTrFrontalSol = false;
            },

            eliminarProbadorTrFrontalSol() {
                this.urlProbadorTrFrontalSol = '';
                this.producto.probador_tr_frontal_sol = '';
            },

            cargarProbadorTrPatitaIzq(event) {
                this.loaderProbadorTrPatitaIzq = true;

                if (this.urlProbadorTrPatitaIzq !== '') {
                    this.$toasted.error('Ya hay un archivo cargado');
                    this.loaderProbadorTrPatitaIzq = false;
                    return;
                }

                if (event.target.files.length > 0) {
                    let imagen = event.target.files[0];
                    this.urlProbadorTrPatitaIzq = URL.createObjectURL(imagen);
                    this.producto.probador_tr_patita_izq = imagen;
                }

                this.loaderProbadorTrPatitaIzq = false;
            },

            eliminarProbadorTrPatitaIzq() {
                this.urlProbadorTrPatitaIzq = '';
                this.producto.probador_tr_patita_izq = '';
            },

            cargarProbadorTrPatitaDer(event) {
                this.loaderProbadorTrPatitaDer = true;

                if (this.urlProbadorTrPatitaDer !== '') {
                    this.$toasted.error('Ya hay un archivo cargado');
                    this.loaderProbadorTrPatitaDer = false;
                    return;
                }

                if (event.target.files.length > 0) {
                    let imagen = event.target.files[0];
                    this.urlProbadorTrPatitaDer = URL.createObjectURL(imagen);
                    this.producto.probador_tr_patita_der = imagen;
                }

                this.loaderProbadorTrPatitaDer = false;
            },

            eliminarProbadorTrPatitaDer() {
                this.urlProbadorTrPatitaDer = '';
                this.producto.probador_tr_patita_der = '';
            },

            mapperImagenes(img, index) {
                const PROFILE_TYPES = {
                    0: 'FRONTAL',
                    1: 'PERFIL',
                    2: 'LATERAL',
                    3: 'CENITAL',
                    DEFAULT: 'OTROS',
                };

                const nombreSeparate = img.nombre.split('.');
                const nombreSinExtencion = nombreSeparate[0] || '';
                const extension = nombreSeparate[1] || '';

                return {
                    idproducto_imagen: img.idproducto_imagen,
                    idproducto: img.idproducto,
                    nombre: nombreSinExtencion,
                    orden: img.orden,
                    perfil: PROFILE_TYPES[index] || PROFILE_TYPES.DEFAULT,
                    url: this.assetAWS('monturas/' + img.nombre),
                    extencion: extension,
                    error: [],
                };
            },

            async cambiarOrdenImagen() {
                this.loaderImagen = true;
                try {
                    const { data } = await this.axios.post('api/panel/productos/ordenarArchivos', {
                        idproducto: this.producto.idproducto,
                        tipoArchivo: 'imagen',
                        imagen: JSON.stringify(this.imagen),
                    });

                    this.$toasted.success(data.mensaje, {
                        icon: 'mdi-check-bold',
                    });

                    this.imagen = data.imagenes.map(this.mapperImagenes);
                } catch (error) {
                    console.error('Error loading images:', error);
                } finally {
                    this.loaderImagen = false;
                }
            },

            async cargarImagenes(event) {
                if (!event.target.files?.length) return;

                this.loaderImagen = true;
                try {
                    const files = event.target.files;
                    const processedFiles = Array.from(files);

                    const form = new FormData();
                    form.append('idproducto', this.producto.idproducto);
                    form.append('tipoArchivo', 'imagen');
                    processedFiles.forEach((file) => {
                        form.append('imagen[]', file);
                        form.append('imagen_nombre[]', file.name);
                    });

                    const { data } = await this.axios.post('api/panel/productos/agregarArchivos', form);

                    this.$toasted.success(data.mensaje, {
                        icon: 'mdi-check-bold',
                    });

                    this.imagen = data.imagenes.map(this.mapperImagenes);
                } catch (error) {
                    console.error('Error loading images:', error);
                } finally {
                    this.loaderImagen = false;
                }
            },

            async eliminarImagen(idproducto_imagen, index) {
                this.loaderImagen = true;
                try {
                    const { data } = await this.axios.post('api/panel/productos/eliminarAchivo', {
                        idproducto: this.producto.idproducto,
                        idproducto_imagen: idproducto_imagen,
                        tipoArchivo: 'imagen',
                    });

                    this.$toasted.success(data.mensaje, {
                        icon: 'mdi-check-bold',
                    });

                    this.imagen.splice(index, 1);
                } catch (error) {
                    console.log(error);
                } finally {
                    this.loaderImagen = false;
                }
            },

            mapperImagenesColor(img, index) {
                const PROFILE_TYPES = {
                    0: 'FRONTAL',
                    1: 'PERFIL',
                    2: 'LATERAL',
                    3: 'CENITAL',
                    DEFAULT: 'OTROS',
                };

                const nombreSeparate = img.nombre.split('.');
                const nombreSinExtencion = nombreSeparate[0] || '';
                const extension = nombreSeparate[1] || '';

                return {
                    idproducto_imagen_color: img.idproducto_imagen_color,
                    idproducto: img.idproducto,
                    nombre: nombreSinExtencion,
                    orden: img.orden,
                    perfil: PROFILE_TYPES[index] || PROFILE_TYPES.DEFAULT,
                    url: this.assetAWS('monturas/' + img.nombre),
                    extencion: extension,
                    error: [],
                };
            },

            async cambiarOrdenImagenesColor() {
                this.loaderImagenColor = true;

                try {
                    const { data } = await this.axios({
                        method: 'POST',
                        url: 'api/panel/productos/ordenarArchivos',
                        data: {
                            idproducto: this.producto.idproducto,
                            tipoArchivo: 'imagen_color',
                            imagen_color: JSON.stringify(this.imagen_color),
                        },
                    });

                    this.$toasted.success(data.mensaje, {
                        icon: 'mdi-check-bold',
                    });

                    this.imagen_color = data.imagenes_color.map(this.mapperImagenesColor);
                } catch (error) {
                    console.log(error);
                } finally {
                    this.loaderImagenColor = false;
                }
            },

            async cargarImagenColor(event) {
                if (!event.target.files?.length) return;

                this.loaderImagenColor = true;

                try {
                    const files = event.target.files;
                    const processedFiles = Array.from(files);

                    const form = new FormData();

                    form.append('idproducto', this.producto.idproducto);
                    form.append('tipoArchivo', 'imagen_color');
                    processedFiles.forEach((file) => {
                        form.append('imagen_color[]', file);
                        form.append('imagen_color_nombre[]', file.name);
                    });

                    const { data } = await this.axios({
                        method: 'POST',
                        url: 'api/panel/productos/agregarArchivos',
                        data: form,
                    });

                    this.$toasted.success(data.mensaje, {
                        icon: 'mdi-check-bold',
                    });

                    this.imagen_color = data.imagenes_color.map(this.mapperImagenesColor);
                } catch (error) {
                    console.log(error);
                } finally {
                    this.loaderImagenColor = false;
                }
            },

            async eliminarImagenesColor(idproducto_imagen_color) {
                this.loaderImagenColor = true;
                try {
                    const { data } = await this.axios({
                        method: 'POST',
                        url: 'api/panel/productos/eliminarAchivo',
                        data: {
                            idproducto: this.producto.idproducto,
                            idproducto_imagen_color: idproducto_imagen_color,
                            tipoArchivo: 'imagen_color',
                        },
                    });

                    this.$toasted.success(data.mensaje, {
                        icon: 'mdi-check-bold',
                    });

                    this.imagen_color = data.imagenes_color.map(this.mapperImagenesColor);
                } catch (error) {
                    console.log(error);
                } finally {
                    this.loaderImagenColor = false;
                }
            },

            getRangos() {
                this.axios({
                    method: 'POST',
                    url: 'api/panel/productos/getRangos',
                    data: {
                        idgenero: this.producto.idgenero,
                    },
                })
                    .then((response) => {
                        if (response.status === 200) {
                            this.resources.rango = response.data.data;

                            if (this.resources.rango.length == 0) {
                                this.producto.idrango_edad = '';
                            }
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            },

            getDatos() {
                this.mostrarContenido = false;

                this.axios({
                    method: 'GET',
                    url: 'api/panel/productos/create',
                })
                    .then((response) => {
                        const status = response.status;
                        const data = response.data;

                        if (status === 200) {
                            this.resources.tipo_producto = data.tipo_producto;
                            this.resources.clase = data.clases;
                            this.resources.categoria = data.categorias;
                            this.resources.marco = data.marcos;
                            this.resources.material = data.materiales;
                            this.resources.forma = data.formas;
                            this.resources.genero = data.generos;
                            this.resources.rostro = data.rostros;
                            this.resources.producto_color = data.producto_color;
                            this.resources.tag = data.tags;
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    });

                this.axios({
                    method: 'GET',
                    url: 'api/panel/productos/' + this.$route.params.idproducto + '/edit',
                })
                    .then((response) => {
                        const status = response.status;
                        const data = response.data;
                        const producto = data.producto;

                        if (status === 200) {
                            Object.assign(this.producto, {
                                ...producto,
                                idclase: producto.clases_pivot,
                                idgenero: producto.generos_pivot,
                                idmaterial: producto.materiales_pivot,
                                idproducto_color: producto.producto_color_pivot,
                                idtag: producto.tags_pivot,
                                idforma: producto.formas_pivot,
                                idrostro: producto.rostros_pivot,
                                relevancia: producto.relevancia || 20,
                                imagenes: [],
                                imagenes_color: [],
                            });

                            if (producto.imagen_probador != null) {
                                this.urlProbadorVirutal = this.assetAWS('monturas/' + producto.imagen_probador);
                            }

                            if (producto.imagen_probador_sol != null) {
                                this.urlProbadorVirutalSol = this.assetAWS('monturas/' + producto.imagen_probador_sol);
                            }

                            if (producto.imagen_cuadrado != null) {
                                this.urlImgCuadrado = this.assetAWS('monturas/' + producto.imagen_cuadrado);
                            }

                            if (producto.probador_tr_frontal != null) {
                                this.urlProbadorTrFrontal = this.assetAWS('monturas/' + producto.probador_tr_frontal);
                            }

                            if (producto.probador_tr_frontal_sol != null) {
                                this.urlProbadorTrFrontalSol = this.assetAWS('monturas/' + producto.probador_tr_frontal_sol);
                            }

                            if (producto.probador_tr_patita_izq != null) {
                                this.urlProbadorTrPatitaIzq = this.assetAWS('monturas/' + producto.probador_tr_patita_izq);
                            }

                            if (producto.probador_tr_patita_der != null) {
                                this.urlProbadorTrPatitaDer = this.assetAWS('monturas/' + producto.probador_tr_patita_der);
                            }

                            if (
                                this.producto.probador_tr_offset_y === null ||
                                this.producto.probador_tr_offset_y === ''
                            ) {
                                this.producto.probador_tr_offset_y = -0.275;
                            }

                            // Sin altura móvil propia: se precarga la que el probador ya usa
                            // en celular (PC + 0.06), así guardar sin tocarla no cambia nada.
                            if (
                                this.producto.probador_tr_offset_y_movil === null ||
                                this.producto.probador_tr_offset_y_movil === '' ||
                                this.producto.probador_tr_offset_y_movil === undefined
                            ) {
                                this.producto.probador_tr_offset_y_movil = Number(
                                    (parseFloat(this.producto.probador_tr_offset_y) + 0.06).toFixed(4)
                                );
                            }

                            this.imagen = producto.imagenes.map(this.mapperImagenes);
                            this.imagen_color = producto.imagenes_color.map(this.mapperImagenesColor);

                            this.getRangos();

                            this.evtTipoProducto();
                        }

                        this.mostrarContenido = true;
                    })
                    .catch((error) => {
                        this.$toasted.error('Ocurrio un error al buscar este registro', {
                            icon: 'mdi-close',
                        });

                        this.$router.push({
                            name: 'productosPanel',
                        });
                    })
                    .finally(() => {});
            },

            modificar() {
                this.processForm = true;
                this.alertError = false;

                if (this.imagen.some((img) => img.error.length > 0)) {
                    this.processForm = false;
                    this.alertError = true;
                    this.listErrors = this.imagen
                        .filter((img) => img.error.length > 0)
                        .flatMap((img, index) => img.error.map((error) => `Imagen ${index + 1}: ${error}`))
                        .map((error) => [error]);
                    this.$vuetify.goTo(this.$refs.mensajeError);
                    return;
                }
                if (this.imagen_color.some((img) => img.error.length > 0)) {
                    this.processForm = false;
                    this.alertError = true;
                    this.listErrors = this.imagen_color
                        .filter((img) => img.error.length > 0)
                        .flatMap((img, index) => img.error.map((error) => `Imagen Color ${index + 1}: ${error}`))
                        .map((error) => [error]);
                    this.$vuetify.goTo(this.$refs.mensajeError);
                    return;
                }

                this.producto.imagen_data = JSON.stringify(
                    this.imagen.map((item) => {
                        return {
                            idproducto_imagen: item.idproducto_imagen,
                            nombre: item.nombre + '.' + item.extencion,
                        };
                    })
                );
                this.producto.imagen_color_data = JSON.stringify(
                    this.imagen_color.map((item) => {
                        return {
                            idproducto_imagen_color: item.idproducto_imagen_color,
                            nombre: item.nombre + '.' + item.extencion,
                        };
                    })
                );

                this.axios({
                    method: 'POST',
                    url: 'api/panel/productos/' + this.producto.idproducto,
                    data: this.serialize(this.producto),
                })
                    .then((response) => {
                        let status = response.status;
                        if (status === 200) {
                            this.$toasted.success(response.data.data, {
                                icon: 'mdi-check-bold',
                            });
                            this.$router.push({
                                name: 'productosPanel',
                            });
                        }
                    })
                    .catch((error) => {
                        let status = error.response.status;
                        if (status === 422) {
                            let arrErrors = error.response.data.errors;
                            this.listErrors = Object.values(arrErrors);
                            this.alertError = true;
                            this.$vuetify.goTo(this.$refs.mensajeError);
                        } else {
                            this.$toasted.error('Ocurrio un error al modificar este registro', {
                                icon: 'mdi-close',
                            });
                        }
                    })
                    .finally(() => {
                        this.processForm = false;
                    });
            },
        },
        created() {
            if (!this.validarPermiso('productos.editar')) {
                this.$toasted.error('Usted no tiene permisos para esta sección', {
                    icon: 'mdi-close',
                });

                this.$router.push({
                    name: 'inicioPanel',
                });
            }
            window.scrollTo(0, 0);

            this.getDatos();
            window.addEventListener('message', this.onMensajeProbadorTr);
        },
        beforeDestroy() {
            window.removeEventListener('message', this.onMensajeProbadorTr);
        },
    };
</script>

<style scoped>
    .cursor-move {
        cursor: move;
    }
</style>
